<template>
		<footer class="footer p-4">© 2019 Copyright <a href="https://www.pharmerit.com"> Pharmerit International</a>. All rights reserved.</footer>
</template>

<script>

export default {
  name: 'Footer'
}

</script>

<style lang="scss">
  @import '../scss/bootstrap-custom.scss';
  @import '../../node_modules/bootstrap/scss/bootstrap.scss';
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue